import * as constants from './actionTypes'
import * as common from './commonActions'
import { objectToFormData } from '../utility/formHelper'
import { handleAPIError } from '../utility/actionHelper'

import Axios from '../axios'
import { serialize } from '../utility/serialization'

export function successRequestingFamilies(response) {
  if (response.status === 200) {
    return { type: constants.ADD_FAMILIES, families: response.data.families }
  } else {
    return { type: constants.UI_ERROR, error: response.data }
  }
}

export function successRequestingFamily(response) {
  if (response.status === 200) {
    return { type: constants.ADD_FAMILY, family: response.data.family }
  } else {
    return { type: constants.UI_ERROR, error: response.data }
  }
}

export function successRequestingFamilyStats(response) {
  if (response.status === 200) {
    return {
      type: constants.GET_FAMILY_STATS,
      family_stats: response.data.stats,
    }
  } else {
    return { type: constants.UI_ERROR, error: response.data }
  }
}

export function successUpdatingFamily(response) {
  if (response.status === 200 || response.status === 201) {
    return { type: constants.UPDATE_FAMILY, family: response.data.family }
  } else {
    return { type: constants.UI_ERROR, error: response.data }
  }
}

export const successAddingFamilyMember = response => {
  const user_division = response.data.user.family.users.find( el =>
    el.id === response.data.user.id
  ).current_division
  return {
    type: constants.ADD_FAMILY_MEMBER,
    user: {
      ...response.data.user,
      current_division: user_division,
    },
  }
}

export const successInvitingFamilyMember = response => {
  if (response.status === 200 || response.status === 201) {
    return {
      type: constants.ADD_FAMILY_MEMBER,
      user: response.data.user,
    }
  } else {
    return { type: constants.UI_ERROR, error: response.data }
  }
}

export function successAddingFamilyEnrollments(response) {
  if (response.status === 200 || response.status === 201) {
    return {
      type: constants.ADD_FAMILY_ENROLLMENTS,
      enrollments: response.data.enrollments,
    }
  } else {
    return { type: constants.UI_ERROR, error: response.data }
  }
}

export function successAddingFamilyMemberEnrollment(response) {
  if (response.status === 200 || response.status === 201) {
    return {
      type: constants.ADD_FAMILY_ENROLLMENT,
      enrollment: response.data.enrollment,
    }
  } else {
    return { type: constants.UI_ERROR, error: response.data }
  }
}

export function successInvitingFamily(response) {
  if (response.status === 200 || response.status === 201) {
    return {
      type: constants.ADD_INVITATION,
      invitation: response.data.invitation,
    }
  } else {
    return { type: constants.UI_ERROR, error: response.data }
  }
}

export function successRemindingFamily(response) {
  if (response.status === 200 || response.status === 201) {
    return {
      type: constants.SEND_FAMILY_REMINDER,
      reminder: response.data.reminder,
    }
  } else {
    return { type: constants.UI_ERROR, error: response.data }
  }
}

// THUNKS HERE
export function getFamilies(community_id) {
  return function(dispatch) {
    // BODY OF THUNK

    // TURN SPINNER ON...
    dispatch(common.loadingChanged(true))
    // FETCH API CALL FROM SERVER THEN DISPATCH UI ACTION
    // THEN TURN SPINNER OFF
    return requestFamilies(community_id)
      .then(response => dispatch(successRequestingFamilies(response)))
      .then(() => dispatch(common.loadingChanged(false)))
  }
}

export function getFamily(family_id, signal) {
  return function(dispatch) {
    // BODY OF THUNK

    // TURN SPINNER ON...
    dispatch(common.loadingChanged(true))
    // FETCH API CALL FROM SERVER THEN DISPATCH UI ACTION
    // THEN TURN SPINNER OFF
    return requestFamily(family_id, signal)
      .then(response => dispatch(successRequestingFamily(response)))
      .then(() => dispatch(common.loadingChanged(false)))
  }
}

export function getFamilyStats(family_id) {
  return function(dispatch) {
    return requestFamilyStats(family_id).then(response =>
      dispatch(successRequestingFamilyStats(response))
    )
  }
}

export function addFamilyMember(user) {
  return function(dispatch) {
    dispatch(common.loadingChanged(true))
    dispatch({ type: constants.UI_ERROR, error: {} })
    return registerAddFamilyMember(user)
      .then(response => dispatch(successAddingFamilyMember(response)))
      .then(() => dispatch(common.loadingChanged(false)))
      .catch(err => {
        dispatch(common.loadingChanged(false))
        dispatch({ type: constants.UI_ERROR, error: err.response.data.errors })

        throw handleAPIError(err)
      })
  }
}

export function inviteFamilyMember(user) {
  return function(dispatch) {
    dispatch(common.loadingChanged(true))
    dispatch({ type: constants.UI_ERROR, error: {} })
    return requestInviteFamilyMember(user)
      .then(response => dispatch(successInvitingFamilyMember(response)))
      .then(() => dispatch(common.loadingChanged(false)))
      .catch(err => {
        dispatch(common.loadingChanged(false))
        dispatch({ type: constants.UI_ERROR, error: err.response.data.errors })

        throw handleAPIError(err)
      })
  }
}

export function reinviteFamilyMember(familyMemberId) {
  return requestReinviteFamilyMember(familyMemberId)
}

export function updateFamily(family_id, family) {
  return function(dispatch) {
    dispatch(common.loadingChanged(true))

    return requestUpdateFamily(family_id, family)
      .then(response => dispatch(successUpdatingFamily(response)))
      .then(() => dispatch(common.loadingChanged(false)))
      .catch(err => {
        dispatch(common.loadingChanged(false))
        throw err
      })
  }
}

export function getFamilyEnrollments(family_id, user_id, status) {
  return function(dispatch) {
    dispatch(common.loadingChanged(true))

    return requestFamilyEnrollments(family_id, user_id, status)
      .then(response => dispatch(successAddingFamilyEnrollments(response)))
      .then(() => dispatch(common.loadingChanged(false)))
  }
}

export function addFamilyMemberEnrollment(user_id, course_id) {
  return function(dispatch) {
    dispatch(common.loadingChanged(true))

    return requestAddFamilyEnrollment(user_id, course_id)
      .then(response => dispatch(successAddingFamilyMemberEnrollment(response)))
      .then(() => dispatch(common.loadingChanged(false)))
  }
}

// TODO: update after members release
export function inviteFamily(user) {
  return function(_dispatch) {
    return requestInviteFamilyAsCoach(user)
    // .then(response => {
    //   dispatch(successInvitingFamily(response))
    // })
  }
}

// export function reinviteFamily(familyAdminId) {
//   return requestReinviteFamilyAsCoach(familyAdminId)
// }

export function sendFamilyReminder(invitation, community_id, coach_id, url) {
  return function(dispatch) {
    return requestFamilyReminder(invitation, community_id, coach_id, url).then(
      response => dispatch(successRemindingFamily(response))
    )
  }
}
// API CALLS
// eslint-disable-next-line max-params
export function requestFamilies(community_id, page, perPage, search, active, signal) {
  const requestUrl = '/api/v1/communities/' + community_id + '/families'
  return Axios.get(requestUrl, { params: serialize({ page, perPage, search, active }), signal })
}

function requestFamily(family_id, signal) {
  const requestUrl = '/api/v1/families/' + family_id
  return Axios.get(requestUrl, { signal })
}

function requestFamilyStats(family_id) {
  const requestUrl = '/api/v1/families/' + family_id + '/stats'
  return Axios.get(requestUrl)
}

function registerAddFamilyMember(newUser) {
  const requestUrl = '/api/v1/student/junior_golfers'
  return Axios.post(requestUrl, objectToFormData(newUser))
}

function requestInviteFamilyMember(newUser) {
  const requestUrl = '/api/v1/student/invitations'
  return Axios.post(requestUrl, objectToFormData(newUser))
}

function requestReinviteFamilyMember(familyMemberId) {
  const requestUrl = `/api/v1/student/invitations/${familyMemberId}`
  return Axios.put(requestUrl)
}

function requestFamilyEnrollments(family_id, user_id, status) {
  const requestUrl = `api/v1/families/${family_id}/enrollments`

  return Axios.get(requestUrl, { params: { user_id, status } })
}

function requestAddFamilyEnrollment(user_id, course_id) {
  const requestUrl = '/api/v1/enrollments'
  return Axios.post(requestUrl, {
    user_id: user_id,
    course_id: course_id,
    status: 'applied',
  })
}

function requestInviteFamilyAsCoach(newUser) {
  const requestUrl = '/api/v1/coach/student/invitations'
  return Axios.post(requestUrl, objectToFormData(newUser))
}

// function requestReinviteFamilyAsCoach(familyAdminId) {
//   const requestUrl = `/api/v1/student/invitations/${familyAdminId}`
//   return Axios.put(requestUrl)
// }

function requestFamilyReminder(invitation, community_id, coach_id, url) {
  const requestUrl = '/api/v1/families/send_reminder'
  return Axios.post(requestUrl, {
    email: invitation.email,
    invitation_id: invitation.id,
    community_id: community_id,
    coach_id: coach_id,
    url,
    new_web: true,
  })
}

function requestUpdateFamily(family_id, family) {
  const requestUrl = '/api/v1/families/' + family_id

  const data = new FormData()

  for (const key in family) {
    if (Object.prototype.hasOwnProperty.call(family, key) && family[key] !== '') {
      data.append(key, family[key])
    }
  }

  return Axios.put(requestUrl, data)
}
